module.exports = __webpack_public_path__ + "static/media/area3.d394da55.png";